/* G4 (5 Oct 2026): "Recently viewed" rail on the PDP and Home. The browser remembers the handles (localStorage, newest first, 12 max);
   each card is the shared Alo card rendered by the store (templates/product.ma-card.liquid), so it is model first, flat on hover, with quick add.
   Nothing is shown until at least 3 other pieces have been viewed. No dependencies; any failure leaves the page as it was. */
(function () {
  if (window.__mxRecent) return; window.__mxRecent = 1;
  var KEY = 'ma_rv', MAX = 12, MIN = 3, SHOW = 8;
  var cls = document.body.className, onPdp = /template-product/.test(cls), onHome = /template-index/.test(cls);
  if (!onPdp && !onHome) return;
  /* the Recently viewed section (data-ma-rv, assets/ma-system.js) already draws this rail with the same card on the PDP and the bag page */
  if (document.querySelector('[data-ma-rv]')) return;
  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string'; }) : []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {} }
  var cur = null;
  if (onPdp) {
    try { var m = JSON.parse(document.querySelector('[data-mx-meta]').textContent); cur = m && m.handle; } catch (e) {}
    if (!cur) { var mm = location.pathname.match(/\/products\/([^/?#]+)/); cur = mm && mm[1]; }
  }
  var list = read();
  var show = list.filter(function (h) { return h !== cur; }).slice(0, SHOW);
  if (cur) write([cur].concat(list.filter(function (h) { return h !== cur; })));
  if (show.length < MIN) return;
  function place(sec) {
    if (onPdp) {
      var r = document.querySelectorAll('.mx-pdp-rails'); var last = r[r.length - 1];
      var host = last ? last.closest('.shopify-section') || last : null;
      if (host) { host.insertAdjacentElement('afterend', sec); return true; }
      var after = document.querySelector('.mx-pdp__after'); if (after) { after.insertAdjacentElement('afterend', sec); return true; }
      return false;
    }
    var rails = document.querySelectorAll('main .shopify-section:has(.mx-rail)'); var l = rails[rails.length - 1];
    if (l) { l.insertAdjacentElement('afterend', sec); return true; }
    return false;
  }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  Promise.all(show.map(function (h) {
    return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?view=ma-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
  })).then(function (parts) {
    var cards = parts.filter(function (t) { return t && t.indexOf('mx-card') > -1; });
    if (cards.length < MIN) return;
    var sec = document.createElement('div'); sec.className = 'shopify-section mx-recent-section';
    var id = 'mx-rail-h-recent';
    sec.innerHTML = '<section class="mx-rail mx-rail--recent" aria-labelledby="' + id + '" data-mx-rail>' +
      '<div class="mx-head"><h2 class="mx-head__h" id="' + id + '">Recently viewed</h2></div>' +
      '<ul class="mx-rail__list mx-scroll" role="list" data-mx-track>' +
      cards.map(function (c) { return '<li class="mx-rail__item">' + c + '</li>'; }).join('') + '</ul></section>';
    if (!place(sec)) return;
    document.dispatchEvent(new Event('shopify:section:load'));
  });
})();
